import { registerCapability } from '../../platform/capability-registry';
import { BareMetalProvisioningBlock } from './BareMetalProvisioningBlock';
import { BARE_METAL_PROVISIONING_FIELD_KEY_LIST } from './fieldKeys';
import { resolveBareMetalProvisioningPaths } from './resolvePaths';
import type { BareMetalProvisioningBlockOptions } from './types';

registerCapability<BareMetalProvisioningBlockOptions>({
  key: 'bare-metal-provisioning',
  fields: [...BARE_METAL_PROVISIONING_FIELD_KEY_LIST],
  component: BareMetalProvisioningBlock,
  defaultPaths: (prefix) => resolveBareMetalProvisioningPaths(prefix),
  resolvePaths: (prefix) => resolveBareMetalProvisioningPaths(prefix),
});
